import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { State } from '@core/modules/error/store/error.reducer';

import * as fromErrorActions from '@core/modules/error/store/error.actions';

@Injectable({
  providedIn: 'root',
})
export class ErrorFacade {
  constructor(private store: Store<State>) {}

  httpExceptionErrorOccurred(message: string) {
    this.store.dispatch(
      new fromErrorActions.HttpExceptionErrorOccurred({ message })
    );
  }
}
